import { LegalDoc } from "../components/LegalDoc";

const SECTIONS = [
  {
    heading: "Interpretazioni simboliche",
    paragraphs: [
      "Le letture offerte da ARCANA sono interpretazioni simboliche delle carte e delle figure geomantiche. Hanno finalità di intrattenimento e di riflessione personale: sono un invito a guardare la tua situazione da un altro punto di vista, non una descrizione di fatti.",
    ],
  },
  {
    heading: "Nessuna certezza sul futuro",
    paragraphs: [
      "Nessuna lettura può garantire o prevedere con certezza eventi futuri. Ogni indicazione, comprese quelle temporali, va intesa come simbolica e indicativa. Le interpretazioni sono generate con l'assistenza di un sistema di intelligenza artificiale e non costituiscono informazioni verificate.",
    ],
  },
  {
    heading: "Non sostituiscono i professionisti",
    paragraphs: [
      "Le letture non sono consulenze mediche, psicologiche, legali o finanziarie. Per questioni di salute, di benessere psicologico, legali o economiche rivolgiti sempre a un professionista qualificato.",
    ],
  },
  {
    heading: "Se stai attraversando un momento difficile",
    paragraphs: [
      "La cartomanzia non è uno strumento adatto ad affrontare una crisi personale. Se ti trovi in difficoltà, parla con qualcuno che può aiutarti davvero:",
    ],
    items: [
      "Emergenze: 112 (numero unico di emergenza, attivo 24 ore su 24).",
      "Telefono Amico Italia: 02 2327 2327 (tutti i giorni, dalle 10 alle 24).",
      "Il tuo medico di fiducia o i servizi di salute mentale della tua zona.",
    ],
  },
  {
    heading: "Le tue decisioni restano tue",
    paragraphs: [
      "Qualunque cosa emerga da una lettura, le scelte sulla tua vita ti appartengono. Usa le carte come uno specchio per riflettere, mai come un ordine da seguire.",
      "Il servizio è riservato a persone maggiorenni (18+).",
    ],
  },
];

export default function Disclaimer() {
  return <LegalDoc title="Disclaimer" tagline="Leggimi con attenzione" updated="12 settembre 2026" sections={SECTIONS} testid="disclaimer-page" />;
}
